// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.chip-wrapper .sk-select__arrow::before {\n  background-color: currentColor;\n}\n.chip-wrapper .sk-select__arrow::after {\n  background-color: currentColor;\n}\n.chip-wrapper .sk-select__arrow {\n  top: 13px;\n  height: auto;\n}\n", ""]);
// Exports
module.exports = exports;
